import { Class, ClassSearchParams } from '@core/models/class.models';
import { GgPaginatedState } from '@core/models/paginated-data.models';

export interface ClassesState extends GgPaginatedState<Class> {
  selected: string[];
  isLoaded: boolean;
  isLoading: boolean;
  searchParams: ClassSearchParams;
}
